/**
 * Created by vsliwka on 30/05/2017.
 */
import { TerritoryModel } from './territory.model';
import { RestrictionModel } from './restriction.model';

export class WorkRestrictionModel {
  public id: number;
  public workId: number;

  /* New Attributes */
  public restriction: RestrictionModel;
  public country: TerritoryModel;

  /* Old Attributes */
  public countryIsoCode: string;
  public label: string;
  public code: string;
  public order: number;

  public type: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
